import { Spin, Tooltip } from 'antd';
import _ from 'lodash';
import { ArrowUpOutlined, ArrowDownOutlined, LoadingOutlined } from '@ant-design/icons';
import { formatNumWithKMBAlt, truncateLabel } from 'utils/helperMethods';
import { KPITileItem } from 'types/pricingSimulator';
import Cross from 'assets/svg/Cross';
import { colorConstants } from 'config/colorConstants';

type props = {
    kpiTile: KPITileItem;
    loading: boolean;
    showPercentage: boolean;
    onTileRemove: (kpiId: number) => void;
    kpiTileCharLimit: number;
    decimalForNonPercentage: number;
    decimalForPercentage: number;
};

const KPITile = ({
    kpiTile,
    loading,
    showPercentage,
    onTileRemove,
    kpiTileCharLimit, // TODO: remove these keys from app config
    decimalForNonPercentage,
    decimalForPercentage,
}: props) => {
    const { label, absChange, percentChange, id, newValue, oldValue } = kpiTile;

    const diffValue = showPercentage ? `${percentChange}%` : formatNumWithKMBAlt(absChange, decimalForPercentage);
    const isPositive = absChange > 0;
    const isSameValue = oldValue === newValue;
    return (
        <div
            className="flex h-24 shadow-lg  w-64 grow  flex-col rounded-lg bg-white my-2 p-2 border border-backgroundGreyAlt1"
            style={{ minWidth: '300px', maxWidth: '300px' }}
        >
            {loading ? (
                <div className="flex justify-center items-center h-3/4" style={{ height: '163.4px' }}>
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
                </div>
            ) : (
                <div className="flex flex-col px-4 justify-between h-full relative">
                    <Tooltip
                        placement="top"
                        color="white"
                        destroyTooltipOnHide
                        overlayStyle={{ borderRadius: 4 }}
                        overlayInnerStyle={{
                            color: colorConstants.darkGrey,
                        }}
                        title={label}
                    >
                        <div className="text-left font-sm text-backgroundGreyAlt2 truncate pr-2">{label}</div>
                    </Tooltip>
                    <div className="flex justify-between items-center ">
                        <div className="font-xl ">
                            {formatNumWithKMBAlt(newValue, decimalForNonPercentage, decimalForNonPercentage)}
                        </div>
                        <div
                            className="font-sm flex justify-center items-center gap-1"
                            style={{
                                color: isSameValue
                                    ? colorConstants.greyAlt15
                                    : isPositive
                                    ? colorConstants.limeGreen
                                    : colorConstants.red,
                            }}
                        >
                            {diffValue}
                            {isSameValue ? <></> : isPositive ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
                        </div>
                        <div className="font-sm text-backgroundGreyAlt2">
                            {formatNumWithKMBAlt(oldValue, decimalForNonPercentage, decimalForNonPercentage)}
                        </div>
                    </div>
                    <div
                        className="absolute right-2 top-2 text-black cursor-pointer"
                        onClick={() => !loading && onTileRemove(id)}
                    >
                        <Cross stroke={colorConstants.blackAlt} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default KPITile;
